//#region src/como_transaction_id_source.ts
var ComoTransactionIdSource = /* @__PURE__ */ function(ComoTransactionIdSource) {
	ComoTransactionIdSource["ClientID"] = "client-id";
	ComoTransactionIdSource["OrderID"] = "order-id";
	ComoTransactionIdSource["SequenceID"] = "sequence-id";
	return ComoTransactionIdSource;
}(ComoTransactionIdSource || {});
//#endregion
export { ComoTransactionIdSource };

//# sourceMappingURL=como_transaction_id_source.js.map